import React, { useEffect } from 'react';
import Lenis from 'lenis';
import { registerLenis } from '../../utils/scroll';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  useEffect(() => {
    // autoRaf: Lenis gestiona su propio bucle rAF y lo detiene en destroy().
    // Evita bucles "zombi" (StrictMode/HMR montan dos veces) que dejarían una
    // instancia destruida peleando el scroll con la viva y romperían scrollTo.
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      autoRaf: true,
    });

    registerLenis(lenis);

    return () => {
      lenis.destroy();
      registerLenis(null);
    };
  }, []);

  return (
    <>
      <main style={{ position: 'relative' }}>{children}</main>
    </>
  );
};

export default Layout;
